export default __webpack_public_path__ + "static/feature_personal_3_img_0-dce11d0691926f67f4e8668f29da9f10.png";